module.exports = __webpack_public_path__ + "img/AnyVanLogo-light.c570ff4.svg";